module.exports = __webpack_public_path__ + "img/microsoft_integration_graphic.7ea03d9d.png";